import { render } from "./DataTable.vue?vue&type=template&id=8f88ac60&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=8f88ac60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f88ac60"],['__file',"src/views/ProductManage/SerialNumberUpgrade/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f88ac60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f88ac60', __exports__)) {
    api.reload('8f88ac60', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=8f88ac60&scoped=true", () => {
    api.rerender('8f88ac60', render)
  })

}


export default __exports__